import { PropertyType, PropertyFormat } from '..';

export interface InputTemplateTypeAndFormat {
    type: PropertyType;
    format?: PropertyFormat;
}
